/// The sentence a refusing door wrote, or `null` when the body carries none.
///
/// Every door that refuses on an entitlement answers with `{error, message}` —
/// a machine code and a sentence naming what to do about it (413
/// `storage_quota_exceeded`, 429 `egress_quota_exceeded`). Pasting the raw body
/// into a toast shows the user JSON, which is what the streaming export did.
///
/// Accepts a parsed body or the raw text, so a `fetch` caller and an axios
/// caller share one unwrap.
export function serverRefusalMessage(body: unknown): string | null {
  if (typeof body === "string") {
    const trimmed = body.trim();
    if (!trimmed.startsWith("{")) return null;
    try {
      return serverRefusalMessage(JSON.parse(trimmed));
    } catch {
      return null;
    }
  }
  if (typeof body !== "object" || body === null) return null;
  const { message, error } = body as { message?: unknown; error?: unknown };
  if (typeof message === "string" && message.trim()) return message;
  // The code alone reads poorly, but it beats a brace-wrapped blob.
  if (typeof error === "string" && error.trim()) return error;
  return null;
}

/// A thrown error's own text, or the fallback when what was thrown is no Error.
export const message = (error: unknown, fallback: string) =>
  error instanceof Error ? error.message : fallback;
